import React from 'react'
import PropTypes from 'prop-types'

function OrganizersTable({organizers, onEdit, onDelete}) {
  return <table className='table'>
    <thead>
      <tr>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th className='modify'>Modify</th>
      </tr>
    </thead>
    <tbody>
      { 
        organizers.map((organizer, index) => {
          return <tr key={index}>
            <td>{organizer.first_name}</td>
            <td>{organizer.last_name}</td>
            <td>{organizer.email}</td>
            <td>{organizer.phone}</td>
            <td>
              <div className='menu-buttons'>
                <button className='btn btn-primary' onClick={() => onEdit(organizer)}>Edit</button>
                <button className='btn btn-danger' onClick={() => onDelete(organizer)}>Delete</button>
              </div>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}

OrganizersTable.propTypes = {
  organizers: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default OrganizersTable

